<script>
  import Wisch from "../Component/Wisch.svelte";
  import { galleryData, galleryUrlData } from "../Api/store";

  function getLocationPath(current) {
    return `${$galleryUrlData}/bild/${parseInt(current) + 1}`;
  }
</script>

{#if $galleryData}
  <Wisch {getLocationPath} overviewUrl={$galleryUrlData} data={galleryData} enableOverview={true} />
{:else}
  <p class="text-center">Galerie wird geladen...</p>
{/if}
